import { useFactsheetOverlayContainer } from './useFactsheetOverlayContainer';

/**
 * Whether the factsheet is rendered inside the catalog's scoped overlay panel
 * rather than as a full-viewport dialog. Single source of truth for every
 * compact-layout decision across FactsheetView, FactsheetHeader, and
 * FactsheetBody.
 */
export const useIsFactsheetCompact = () => !!useFactsheetOverlayContainer().container;
